import { Input } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: "app-arrival-thread-group",
  templateUrl: "./arrival-thread-group.component.html",
  styleUrls: ["./arrival-thread-group.component.less"],
})
export class ArrivalThreadGroupComponent implements OnInit {
  threadGroupForm: any;
  showAdvancedOptions = false;
  @Input() data: any;
  @Input() edited: any;
  @Output() notifyParent: EventEmitter<any> = new EventEmitter();
  @Output() cancelCreation: EventEmitter<any> = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    private modelService: NgbModal
  ) {
    this.setForm();
  }

  ngOnInit() {
    if(this.data !== null && this.data !== undefined) {
      this.threadGroupForm.patchValue(this.data);
    }
  }

  setForm() {
    this.threadGroupForm = this.formBuilder.group({
      targetRate: [1, Validators.required],
      rampUpTime: [0, Validators.required],
      rampUpStepsCount: [0],
      holdTargetRateTime: [1, Validators.required],
      concurrencyUserLimit : [500, null]
    });
  }

  updateConcurrencyUserLimit(event: any) {
    let targetRate = event.target.valueAsNumber;
    if(targetRate <= 500) {
      this.threadGroupForm.controls['concurrencyUserLimit'].setValue(500);
    } else {
      this.threadGroupForm.controls['concurrencyUserLimit'].setValue(targetRate);
    }
  }

  saveConfiguration() {
    this.notifyParent.emit({ data : this.threadGroupForm.value, edited :  this.edited });
  }

  cancelThreadGroupCreation() {
    this.threadGroupForm.reset();
    this.cancelCreation.emit();
  }

  updateConfiguration() {
    this.notifyParent.emit({ data : this.threadGroupForm.value, edited :  this.edited });
  }

  updateRampUpTime(data: any) {
    this.threadGroupForm.controls['rampUpStepsCount'].setValue(data.target.value);
  }
}